module.exports = __webpack_public_path__ + "img/Table_view_white.c9c39250.svg";